import React from 'react'
import NavigationBar from '../Commons/NavigationBar'
import CreateEpsForm from './EpsForm'
import _ from 'lodash'

export default class EpsComponent extends React.Component {
  constructor (props) {
    super(props)
    this.state = ({ eps: '', isUpdate: false })
  }

  componentWillMount () {
    if (!_.isEmpty(this.props.params)) {
      this.setState({ eps: this.props.params.eps, isUpdate: true })
    }
  }

  render () {
    document.title = 'Registrar EPS - CORE 3.0'
    return (
      <div className='main-information-container'>
        <NavigationBar/>
        <div className='registration-container-eps'>
          <div className='eps-profile'>
            <CreateEpsForm epsName={this.state.eps} isUpdate={this.state.isUpdate} />
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/EPS/EpsComponent.js